'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = computors;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../utils/constants');

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    axisRange: function axisRange(options) {
      var orient = target.accessors.orient(options);

      var _target$accessors$mar = target.accessors.margin(options),
          bottom = _target$accessors$mar.bottom,
          left = _target$accessors$mar.left,
          right = _target$accessors$mar.right,
          top = _target$accessors$mar.top;

      if (orient === _constants.BOTTOM || orient === _constants.TOP) {
        return [left, target.accessors.width(options) - right];
      } else {
        return [top, target.accessors.height(options) - bottom];
      }
    },
    axisScale: function axisScale(options, data) {
      return _d2.default.scale.linear().domain(target.computors.domain(options, data)).range(target.computors.axisRange(options));
    },
    axisTicks: function axisTicks(options, data) {
      var scale = target.computors.colorScale(options, data);
      var colors = target.accessors.colors(options);
      return R.pipe(R.map(function (color) {
        return scale.invertExtent(color);
      }), R.unnest, R.uniq)(colors);
    },
    axisOffset: function axisOffset(selection, options) {
      var orient = target.accessors.orient(options);
      if (orient === _constants.LEFT || orient === _constants.RIGHT) {
        return (0, _utils.getElementDimensions)(selection).width;
      }
      return (0, _utils.getElementDimensions)(selection).height;
    },
    axisTranslate: function axisTranslate(offset, options) {
      var orient = target.accessors.orient(options);

      var _target$accessors$mar2 = target.accessors.margin(options),
          bottom = _target$accessors$mar2.bottom,
          left = _target$accessors$mar2.left,
          right = _target$accessors$mar2.right,
          top = _target$accessors$mar2.top;

      var width = target.accessors.width(options);
      var height = target.accessors.height(options);
      if (orient === _constants.TOP) {
        return 'translate(0, ' + (offset + top) + ')';
      } else if (orient === _constants.BOTTOM) {
        return 'translate(0, ' + (height - offset - bottom) + ')';
      } else if (orient === _constants.LEFT) {
        return 'translate(' + (offset + left) + ', 0)';
      } else if (orient === _constants.RIGHT) {
        return 'translate(' + (width - offset - right) + ', 0)';
      }
    },
    axis: function axis(options, data) {
      var tickSize = target.accessors.tickSize(options);
      return _d2.default.svg.axis().scale(target.computors.axisScale(options, data)).orient(target.accessors.orient(options)).tickSize(tickSize, tickSize).tickFormat((0, _utils.getFormat)(target.accessors.format(options))).tickValues(target.computors.axisTicks(options, data));
    },
    colorBars: function colorBars(options, data, offset) {
      var colorScale = target.computors.colorScale(options, data);
      var axisScale = target.computors.axisScale(options, data);
      var width = target.accessors.width(options);
      var height = target.accessors.height(options);
      var orient = target.accessors.orient(options);

      var _target$accessors$mar3 = target.accessors.margin(options),
          bottom = _target$accessors$mar3.bottom,
          left = _target$accessors$mar3.left,
          right = _target$accessors$mar3.right,
          top = _target$accessors$mar3.top;

      return R.map(function (color) {
        var _colorScale$invertExt = colorScale.invertExtent(color),
            _colorScale$invertExt2 = (0, _slicedToArray3.default)(_colorScale$invertExt, 2),
            minExtent = _colorScale$invertExt2[0],
            maxExtent = _colorScale$invertExt2[1];

        var colorRange = axisScale(maxExtent) - axisScale(minExtent);
        if (orient === _constants.LEFT || orient === _constants.RIGHT) {
          return {
            height: colorRange,
            width: width - offset - right - left,
            y: axisScale(minExtent),
            x: left + (orient === _constants.LEFT ? offset : 0),
            color: color
          };
        }
        return {
          width: colorRange,
          height: height - offset - top - bottom,
          x: axisScale(minExtent),
          y: top + (orient === _constants.TOP ? offset : 0),
          color: color
        };
      }, target.accessors.colors(options));
    }
  });
}